var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry"},[_c('div',{staticClass:"error"},[_c('div',{staticClass:"error_bg"},[_c('div',{staticClass:"error_inner"},[_c('h1',{staticClass:"error_title"},[_vm._v("500")]),_c('h4',{staticClass:"error_subtitle"},[_vm._v(_vm._s(_vm.$t('title.error')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }